import React from 'react';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer/index';
import HeroSection from '../../components/home/internet-rumah/HeroSection';
import PromoSection from '../../components/home/internet-rumah/PromoSection';
import SpeedTestSection from '../../components/home/internet-rumah/SpeedTestSection';
import PackagesSection from '../../components/home/internet-rumah/PackagesSection';
import { useDarkMode } from '../../components/darkmode/DarkModeContext';

const InternetRumahPage = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <div
      className="min-h-screen bg-cover bg-center transition-colors duration-300"
      style={{
        backgroundImage: "url('https://telnet.net.id/assets/bg.png')",
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay',
      }}
    >
      <style>
        {`
          .hero-gradient {
            background: linear-gradient(135deg, #1a1a1a 0%, #1E9B4C 50%, #1E9B4C 100%);
          }

          .package-card {
            transition: all 0.3s ease;
            background: linear-gradient(145deg, ${
              isDarkMode ? '#1f2937, #111827' : '#ffffff, #f9fafb'
            });
          }

          .package-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 25px 50px -12px rgba(30, 155, 76, 0.4);
          }

          .package-card.popular {
            border: 2px solid #1E9B4C;
            position: relative;
          }

          .package-card.popular::before {
            content: '';
            position: absolute;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            background: linear-gradient(45deg, #1E9B4C, #15803d, #1E9B4C);
            border-radius: inherit;
            z-index: -1;
            animation: borderGlow 3s ease-in-out infinite;
          }

          @keyframes borderGlow {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }

          .feature-icon {
            background: linear-gradient(135deg, #15803d, #1E9B4C);
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
          }

          .promo-card {
            transition: all 0.3s ease;
          }

          .promo-card:hover {
            transform: translateY(-5px);
          }

          .comparison-table {
            background: linear-gradient(145deg, ${
              isDarkMode ? '#1f2937, #111827' : '#ffffff, #f9fafb'
            });
          }

          .tab-button.active {
            background: linear-gradient(135deg, #15803d, #1E9B4C);
          }

          .countdown-item {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }

          .glass-effect {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }

          .pulse-animation {
            animation: pulse 2s infinite;
          }

          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }

          .wifi-floating {
            animation: float 6s ease-in-out infinite;
          }

          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }

          .speed-indicator {
            background: linear-gradient(45deg, #10b981, #1E9B4C);
            animation: speedPulse 2s ease-in-out infinite;
          }

          @keyframes speedPulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.7; }
          }
        `}
      </style>

      <Navbar />
      <HeroSection />
      <PromoSection />
      <SpeedTestSection />
      <PackagesSection />
      <Footer />
    </div>
  );
};

export default InternetRumahPage;